import React from 'react';

export const AllSpecies = ({ size = 18, ...rest }) => {
	return (
		<svg fill="#FEB45F" width="18" height="18" viewBox="0 0 24 24" id="fish" data-name="Flat Color" xmlns="http://www.w3.org/2000/svg" class="icon flat-color"><path id="primary" d="M22,11.71C21.37,9.74,19,6,14.5,6A10.44,10.44,0,0,0,8.19,8.37a6.64,6.64,0,0,0-.9-.68,4.62,4.62,0,0,0-4.84,0A1,1,0,0,0,2,8.51,5.43,5.43,0,0,0,3.42,12,5.43,5.43,0,0,0,2,15.49a1,1,0,0,0,.45.83,4.6,4.6,0,0,0,4.84,0,5.4,5.4,0,0,0,.9-.67A10.44,10.44,0,0,0,14.5,18C19,18,21.37,14.26,22,12.29A1.14,1.14,0,0,0,22,11.71Z" style={{ fill: "#FEB45F" }}></path></svg>

	);
};